import React from 'react';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

const PhoneInput = ({ setFieldTouched, setFieldValue, error, touched, value }) => {
  return (
    <div className="w-full md:w-1/2 md:pl-2 mb-6">
      <label tabIndex="0" className="absolute focus:outline-none" htmlFor="phoneNumber">
        <span className="z-10 relative -top-3 pl-3 text-xs text-gray-600">Phone Number</span>
      </label>
      <IntlTelInput
        fieldName="phoneNumber"
        fieldId="phoneNumber"
        preferredCountries={['gh']}
        value={value}
        inputClassName={`form-control w-full px-3 py-4 bg-gray-200 border-b ${
          error && touched ? 'border-red-700' : 'border-cf-300'
        } focus:outline-none leading-tight text-sm text-gray-700`}
        onPhoneNumberBlur={(status, value, countryData) => {
          setFieldTouched('phoneNumber', true);
          if (!status) {
            setFieldValue('phoneNumber', 'error');
          } else {
            setFieldValue('phoneNumber', value);
            setFieldValue('country', countryData.name.split(' (', 1).toString());
          }
        }}
        onPhoneNumberChange={(status, value, countryData) => {
          setFieldTouched('phoneNumber', true);
          if (!status) {
            setFieldValue('phoneNumber', 'error');
          } else {
            setFieldValue('phoneNumber', value);
            setFieldValue('country', countryData.name.split(' (', 1).toString());
          }
        }}
        style={{ display: 'block' }}
      />
      {error && touched ? <p className="text-xs text-red-700">{error}</p> : null}
    </div>
  );
};

export default PhoneInput;
